/* global google */

import $ from 'jquery';
import MarkerClusterer from '@googlemaps/markerclustererplus';

import {
  i18n, warn, parseTemplate, ajaxSettings,
} from '../common/helpers';
import Office from './Office';

class Location {
  constructor($element, {
    points, zip, country, message, center = [0, 0], onRefresh = () => {},
    finder = false,
    searchWidgetClass = 'SearchBox',
  }) {
    this.$el = $element;

    this.$title = $('.js-location-title');
    this.$map = this.$el.find('.location__map');
    this.$search = this.$el.find('.location-search__input');
    this.$gps = this.$el.find('.location-search__button_gps');
    this.$reload = this.$el.find('.location-search__button_reload');
    this.$list = this.$el.find('.location__list');
    this.$noPudo = $('#no-pudo-message');

    this.officeTemplate = $('#location__office-template').html();
    this.lastOfficePosition = null;

    this.geocoder = new google.maps.Geocoder();
    this.zoom = this.constructor.MIN_ZOOM;
    this.country = country;
    this.countryBounds = null;
    this.prevRequest = {
      [this.$search.is('input') ? 'address' : 'zip']: zip,
    };
    this.onRefresh = onRefresh;
    this.finder = finder;
    this.searchWidgetClass = searchWidgetClass;

    this.initMap();
    this.handleReload();
    this.handleAutocomplete();
    this.handleUserLocation();
    this.setMap(message, new google.maps.LatLng(center[0], center[1]), points);

    const self = this;
    this.$list.on(`change${this.constructor.NAMESPACE}`, '.location__office', function officeChange() {
      const marker = $(this).data('office').getMarker();

      if (marker) {
        self.map.panTo(marker.position);
      }
    });
  }

  initMap() {
    this.map = new google.maps.Map(this.$map[0], {
      center: new google.maps.LatLng(0, 0),
      zoom: this.zoom || this.constructor.MIN_ZOOM,
      mapTypeControl: true,
      streetViewControl: false,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
      },
    });

    this.map.addListener('idle', () => {
      this.center = this.map.getCenter();
      this.zoom = this.map.getZoom();
    });

    this.markers = [];

    this.markerCluster = new MarkerClusterer(this.map, this.markers, {
      ignoreHidden: true,
      gridSize: 80,
      maxZoom: 14,
      styles: [
        {
          width: 35,
          height: 35,
          className: 'cluster-icon-s',
        },
        {
          width: 40,
          height: 40,
          className: 'cluster-icon-m',
        },
        {
          width: 45,
          height: 45,
          className: 'cluster-icon-l',
        },
      ],
      clusterClass: 'cluster-icon',
    });
  }

  getUserMarker() {
    return new google.maps.Marker({
      position: this.userLocation,
      map: this.map,
      icon: {
        path: 'M7 6a3 3 0 0 1 0-6 3 3 0 0 1 0 6zM7 7C3.13 7 0 10.13 0 14c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z',
        fillColor: '#000',
        fillOpacity: 1,
        scale: 1.35,
        strokeColor: '#fff',
        strokeWeight: 0.5,
        anchor: new google.maps.Point(7, 27),
      },
      title: i18n('Your location'),
    });
  }

  getCountryBounds() {
    const dfd = $.Deferred();

    if (this.countryBounds) {
      dfd.resolve(this.countryBounds);
    } else {
      this.geocoder.geocode({
        address: this.country,
      }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK && results[0]) {
          dfd.resolve(results[0].geometry.viewport);
        }

        dfd.reject(`Geocoder failed to get country info. Status: ${status}`);
      });
    }

    return dfd.promise();
  }

  getIcon(serviceID) {
    const svg = `<svg width="43" height="49" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M21.454 4.391c-9.436 0-17.163 7.664-17.163 17.112v.026a14.606 14.606 0 0 0 .043 1.104c.012.205.024.41.047.617-.014.013 0 .026 0 .026C5.636 36.466 21.493 44.39 21.493 44.39S37.495 36.39 38.605 23.25c.019-.23.038-.472.05-.701.026-.331.038-.676.038-1.02v-.025c0-9.373-7.727-17.113-17.239-17.113zm0 28.576c6.031 0 10.89-5.114 10.89-11.4v-.038c-.026-6.35-4.872-11.502-10.89-11.502-5.942 0-10.787 5.151-10.812 11.502v.038c0 6.286 4.857 11.4 10.812 11.4z" fill="#fff"/><path d="M32.344 21.567c0 6.286-4.859 11.4-10.89 11.4-5.955 0-10.812-5.114-10.812-11.4v-.038c.025-6.35 4.87-11.502 10.812-11.502 6.018 0 10.864 5.151 10.89 11.502v.038z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.493 44.391S5.636 36.465 4.381 23.276c0 0-.014-.013 0-.026-.023-.206-.035-.412-.047-.617l-.004-.071a14.606 14.606 0 0 1-.038-1.034v-.025c0-9.448 7.726-17.112 17.162-17.112 9.512 0 17.238 7.74 17.239 17.113v.025c0 .344-.012.689-.038 1.02-.012.23-.032.471-.05.701-1.11 13.139-17.112 21.141-17.112 21.141zm21.154-21.586c.032-.428.046-.858.046-1.276v-.025C42.692 9.906 33.159.391 21.454.391 9.826.391.292 9.828.292 21.503v.026c0 .442.017.873.046 1.291l.004.075c.008.13.018.305.035.5.005.16.02.314.042.46.836 7.996 5.968 14.071 10.345 17.926a48.244 48.244 0 0 0 6.1 4.55c.821.518 1.509.916 2.001 1.19a29.633 29.633 0 0 0 .758.407l.052.026.018.01.01.004s.002.001 1.79-3.577l-1.788 3.578 1.788.894 1.79-.894-1.79-3.578c1.79 3.578 1.79 3.577 1.792 3.577l.009-.005.017-.01.053-.026c.043-.022.1-.051.172-.09.143-.075.342-.181.59-.32a43.264 43.264 0 0 0 2.016-1.197 48.525 48.525 0 0 0 6.133-4.57c4.425-3.894 9.631-10.06 10.315-18.163l.001-.012c.017-.207.04-.486.056-.77z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.454 4.391c-9.436 0-17.163 7.664-17.163 17.112v.026a14.606 14.606 0 0 0 .043 1.104c.012.205.024.41.047.617-.014.013 0 .026 0 .026C5.636 36.466 21.493 44.39 21.493 44.39S37.495 36.39 38.605 23.25c.019-.23.038-.472.05-.701.026-.331.038-.676.038-1.02v-.025c0-9.373-7.727-17.113-17.239-17.113zm0 28.576c6.031 0 10.89-5.114 10.89-11.4v-.038c-.026-6.35-4.872-11.502-10.89-11.502-5.942 0-10.787 5.151-10.812 11.502v.038c0 6.286 4.857 11.4 10.812 11.4z" fill="${this.labels[serviceID] ? this.labels[serviceID].color : this.colors[0].value}"/></svg>`;
    const width = 43;
    const height = 49;
    const scale = 1;
    return {
      scale,
      url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(svg),
      anchor: new google.maps.Point(width / 2 * scale, height * scale),
    };
  }

  setMinimalZoom() {
    const zoom = Math.min(this.map.getZoom(), this.constructor.MIN_ZOOM);
    this.map.setZoom(zoom);
  }

  setMap(message, center, points = []) {
    if (this.userLocation) {
      // If user location available then the center parameter is equal to its position
      if (this.userMarker) {
        this.userMarker.setPosition(this.userLocation);
      } else {
        this.userMarker = this.getUserMarker();
      }

      this.markers.push(this.userMarker);

      // Reset user location for next requests
      this.userLocation = null;
    }

    if (points.length > 0) {
      // Show points
      this.$map.parent().removeClass('hidden');
      this.$noPudo.addClass('hidden');

      this.$title.text(i18n('Your nearest drop-off points'));
      this.createLabels(points);
      this.addPoints(points);
      this.setMinimalZoom();
    } else {
      this.$map.parent().addClass('hidden');
      if ($('.courier').length) {
        this.$noPudo.removeClass('hidden');
      }

      if (message) {
        // Address not found - show full country
        this.getCountryBounds().done((countryBounds) => {
          this.$title.text(message);
          this.map.fitBounds(countryBounds);
          this.map.setZoom(this.map.getZoom() + 1);
        }).fail(error => warn(error));
      } else {
        // Points not found - show map center and user marker on it (if available)
        this.$title.text(i18n('Drop-off points not found'));
        this.map.setCenter(center || this.center);
        this.setMinimalZoom();
      }
    }
  }

  createLabels(points) {
    this.labels = {};
    this.colors = [
      { value: '#91A3FF' },
      { value: '#C8AF84' },
      { value: '#D5E223' },
      { value: '#C372B2' },
      { value: '#E7504C' },
      { value: '#F27134' },
      { value: '#41CC8D' },
      { value: '#707480' },
      { value: '#EC4E9C' },
      { value: '#0026E5' },
      { value: '#231F20' },
    ];

    const serviceIds = [...new Set(points.map((point) => point.service))];

    serviceIds.forEach((serviceID, index) => {
      const color = this.colors[index % this.colors.length];
      this.labels[serviceID] = { color: color.value };
    });
  }

  addPoints(points) {
    let $offices = $();

    points.forEach((point) => {
      let marker = null;
      const $office = $(parseTemplate(this.officeTemplate, point));

      if (point.lat !== null && point.lng !== null) {
        const position = new google.maps.LatLng(point.lat, point.lng);

        marker = new google.maps.Marker({
          map: this.map,
          position,
          draggable: false,
          icon: this.getIcon(point.service),
          title: point.title,
          $office,
        });

        marker.addListener('click', () => {
          const currentOfficePosition = $office.position().top - 5;
          if (this.lastOfficePosition === currentOfficePosition) {
            return;
          }
          const $scroller = this.$list.parent();
          $scroller.scrollTop(0);
          $scroller.animate({
            scrollTop: $scroller.scrollTop() + currentOfficePosition,
          }, 500);

          this.lastOfficePosition = currentOfficePosition;
        });

        this.markers.push(marker);
      }

      $office.data('office', new Office($office, marker, 'select_shop'));
      $offices = $offices.add($office);
    });

    this.markerCluster.addMarkers(this.markers);

    this.$list.append($offices);
    const latLngBounds = this.markers.reduce((bounds, marker) => {
      bounds.extend(marker.position);
      return bounds;
    }, new google.maps.LatLngBounds());
    this.map.setCenter(latLngBounds.getCenter());
    // Show all markers for the proper clustering (should be fixed when markers outside
    // the viewport will automatically hide)
    this.map.fitBounds(latLngBounds);

    google.maps.event.addListenerOnce(this.map, 'bounds_changed', () => {
      this.setMinimalZoom();
    });
  }

  clear() {
    this.$list.empty();
    if (this.markerCluster) {
      this.markerCluster.clearMarkers();
    }
    this.markers = [];
  }

  refresh(position, types) {
    if (this.finder) {
      // For drop-off points finder
      this.map.setZoom(this.constructor.MIN_ZOOM);
      this.setMap(false, position);
    } else {
      // For select shipping
      const searchString = $.trim(this.$search.val());
      const data = {};

      if (this.$search.is('input')) {
        // If search input is textbox then looking for the free-form address
        data.address = searchString;
      } else {
        // If search input is dropdown (for Hong Kong and Malta) then zip is explicitly known
        data.zip = searchString;
      }

      if (position) {
        // User has selected an option from Google SearchBox or have tried to locate himself
        data.lat = position.lat();
        data.lng = position.lng();
      }

      if (types) {
        // User has selected an option from Google SearchBox
        if (types.indexOf('country') !== -1) {
          data.type = 'country';
        }

        if (types.indexOf('continent') !== -1) {
          data.type = 'continent';
        }
      }

      // If the search request is different from the previous one then get new points
      // Order of properties is constant so we can use JSON.stringify for simplicity
      if (JSON.stringify(this.prevRequest) !== JSON.stringify(data)) {
        this.$gps.prop('disabled', true);
        this.constructor.toggleButton(this.$reload, true, i18n('Looking for new drop-off points...'));

        const settings = {
          url: '/main/get_new_marks_for_map',
          method: 'GET',
          data,
          dataType: 'json',
          noPreloader: true,
        };
        const debugSettings = {
          page: 'shipping',
          actions: ['not-found', 'points', 'no-points'],
          noNext: true,
        };

        $.ajax(ajaxSettings(settings, debugSettings)).done(
          /**
           * @param {{
           *   error: string|undefined,
           *   map_center: [number, number]|undefined,
           *   map_marks: Array<{
           *     id: number,
           *     carrier: number,
           *     service: number,
           *     title: string,
           *     address: string,
           *     hours: string,
           *     lat: number|null,
           *     lng: number|null,
           *   }>|undefined,
           * }} json Response of `action_get_new_marks_for_map()`: either `{error}` on failure,
           *   or `{map_marks, map_center?}` (with the fields listed above) on success.
           */
          (json) => {
            this.clear();
            this.setMap(json.error, position, json.map_marks);
            this.prevRequest = data;

            this.onRefresh();
          },
        ).always(() => {
          this.$gps.prop('disabled', false);
          this.constructor.toggleButton(this.$reload, false, i18n('Look for new drop-off points'));
        });
      }
    }
  }

  handleReload() {
    this.$reload.on(`click${this.constructor.NAMESPACE}`, () => this.refresh());

    if (this.$search.is('select')) {
      this.$search.on(`change${this.constructor.NAMESPACE}`, () => this.refresh());
    }
  }

  handlePlaceChanges(widget, eventName, placeResolver) {
    widget.addListener(eventName, () => {
      const place = placeResolver();
      if (place) {
        // If user have chosen any element from search results then reload map
        this.refresh(place.geometry.location, place.types);
      }
    });
  }

  handleAutocomplete() {
    if (this.$search.is('input')) {
      let searchWidget;
      switch (this.searchWidgetClass) {
        case 'Autocomplete':
          searchWidget = new google.maps.places.Autocomplete(this.$search[0], {
            fields: ['geometry.location', 'types'],
          });
          searchWidget.bindTo('bounds', this.map);
          this.handlePlaceChanges(searchWidget, 'place_changed', () => searchWidget.getPlace());
          break;

        default:
          searchWidget = new google.maps.places.SearchBox(this.$search[0]);
          searchWidget.bindTo('bounds', this.map);
          this.handlePlaceChanges(searchWidget, 'places_changed', () => {
            const places = searchWidget.getPlaces();
            return (places.length !== 0) ? places[0] : null;
          });
      }

      this.$search.on(`keydown${this.constructor.NAMESPACE}`, (event) => {
        if (event.keyCode === 13) {
          // Don't send a full form if user pressed "Enter" key
          event.preventDefault();

          // If user enters some text and search results is empty then reload map
          const isSearchResultsHidden = !$('.pac-container:visible').length;
          if (isSearchResultsHidden) {
            this.refresh();
          }
        }
      });
    }
  }

  handleUserLocation() {
    this.userLocation = null;
    this.userMarker = null;

    if (window.navigator.geolocation) {
      this.$search.addClass('location-search__input_gps');

      this.$gps.on(`click${this.constructor.NAMESPACE}`, (event) => {
        event.preventDefault();

        this.$gps.removeClass(this.constructor.GPS_ERROR);
        this.constructor.toggleButton(this.$gps, true, i18n('Looking for your position...'));

        navigator.geolocation.getCurrentPosition((position) => {
          // Get user location
          this.userLocation = new google.maps.LatLng(
            position.coords.latitude, position.coords.longitude,
          );

          this.geocoder.geocode({
            latLng: this.userLocation,
          }, (results, status) => {
            this.constructor.toggleButton(this.$gps, false, i18n('Find near my location'));

            if (status === google.maps.GeocoderStatus.OK && results[0]) {
              this.$search.filter('input').val(results[0].formatted_address);
              this.refresh(this.userLocation);
            }
          });
        }, (error) => {
          warn(error.message);

          let message;
          let isError = false;
          switch (error.code) {
            case 1: // PERMISSION_DENIED
              message = i18n('User denied Geolocation');
              isError = true;
              break;
            case 2: // POSITION_UNAVAILABLE
              message = i18n('Position unavailable');
              isError = true;
              break;
            case 3: // TIMEOUT
              message = i18n('Timeout expired');
              break;
            default: // Something else
              message = i18n('Unexpected error');
              break;
          }

          this.$gps.toggleClass(this.constructor.GPS_ERROR, isError);
          this.constructor.toggleButton(this.$gps, false, message);
        }, { timeout: 5000 });
      });
    }
  }

  static toggleButton($button, isDisabled, message) {
    $button
      .prop('disabled', isDisabled)
      .attr('title', message)
      // .attr('aria-label', message);
      .find('.hidden_sr')
      .text(message);
  }
}

Location.NAMESPACE = '.location';
Location.MIN_ZOOM = 17;
Location.GPS_ERROR = 'location-search__button_gps_error';
Location.INFO_WINDOW = 'info-window';

export default Location;
